import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useEffect, useMemo } from "react";
import { useTranslations } from "next-intl";
import { useSiteInfo } from "@silvertours/front-entities";
import { useSearchInitializer } from "./useInitializeSearchContext";
import { useSession } from "../hooks";
import { ActionType } from "./types";
import { getSearchHistory } from "../SearchHistory";
import { DEFAULT_VALUES, makeTranslatedSearchReducer } from "./reducer";
export var SearchContext = /*#__PURE__*/ React.createContext({
    clearSearchHistory: function() {
        return null;
    },
    getInputValue: function() {
        return "";
    },
    isInternalCall: false,
    setCustomerAge: function() {
        return null;
    },
    setDate: function() {
        return null;
    },
    setInputValue: function() {
        return null;
    },
    makeSetLocation: function() {
        return function() {
            return null;
        };
    },
    setError: function() {
        return null;
    },
    setSearchFromHistory: function() {
        return null;
    },
    setShowDestLocation: function() {
        return null;
    },
    state: null,
    validate: function() {
        return null;
    }
});
var SearchProvider = function(param) {
    var children = param.children, pageData = param.pageData;
    var t = useTranslations("features.stageLegacy.stage.searchForm");
    var searchReducer = makeTranslatedSearchReducer(t);
    var initializeFormState = useSearchInitializer().initializeFormState;
    var getSessionData = useSession().getSessionData;
    var ref = useSiteInfo(), isInternalCall = ref.settings.isInternalCall;
    var ref1 = _sliced_to_array(React.useReducer(searchReducer, DEFAULT_VALUES, function(defaultValues) {
        return initializeFormState(defaultValues, (pageData === null || pageData === void 0 ? void 0 : pageData.location) || null);
    }), 2), state = ref1[0], dispatch = ref1[1];
    var validate = function() {
        dispatch({
            type: ActionType.VALIDATE
        });
    };
    var setCustomerAge = function(customerAge) {
        dispatch({
            type: ActionType.SET_CUSTOMER_AGE,
            payload: {
                customerAge: customerAge
            }
        });
    };
    var setDate = function(direction, date) {
        dispatch({
            type: ActionType.SET_DATE,
            payload: {
                direction: direction,
                date: date
            }
        });
    };
    var makeSetLocation = function(direction) {
        return function(_location) {
            dispatch({
                type: ActionType.SET_LOCATION,
                payload: {
                    direction: direction,
                    location: _location
                }
            });
        };
    };
    var setError = function(error) {
        dispatch({
            type: ActionType.SET_ERROR,
            payload: error
        });
    };
    var setShowDestLocation = function(show) {
        dispatch({
            type: ActionType.SET_SHOW_DEST_LOCATION,
            payload: show
        });
    };
    var setSearchFromHistory = function(payload) {
        dispatch({
            type: ActionType.SET_SEARCH_FROM_HISTORY,
            payload: payload
        });
    };
    var clearSearchHistory = function() {
        dispatch({
            type: ActionType.CLEAR_SEARCH_HISTORY
        });
    };
    var setInputValue = function(direction, value) {
        dispatch({
            type: ActionType.SET_LOCATION_INPUT_VALUE,
            payload: {
                direction: direction,
                value: value
            }
        });
    };
    // Session data must be initialized here because it is not available in SSR
    useEffect(function() {
        var ref;
        var data = getSessionData(pageData === null || pageData === void 0 ? void 0 : (ref = pageData.location) === null || ref === void 0 ? void 0 : ref.cityName);
        var history = getSearchHistory();
        if (data && !(pageData === null || pageData === void 0 ? void 0 : pageData.location)) {
            dispatch({
                type: ActionType.POPULATE_FORM,
                payload: data
            });
        }
        if (history) {
            dispatch({
                type: ActionType.POPULATE_HISTORY_ITEMS,
                payload: {
                    history: history
                }
            });
        }
    }, [
        getSessionData,
        pageData === null || pageData === void 0 ? void 0 : pageData.location
    ]);
    var value = useMemo(function() {
        return {
            clearSearchHistory: clearSearchHistory,
            getInputValue: function(direction) {
                return state.inputValue[direction];
            },
            isInternalCall: isInternalCall,
            setCustomerAge: setCustomerAge,
            setDate: setDate,
            setError: setError,
            state: state,
            setInputValue: setInputValue,
            makeSetLocation: makeSetLocation,
            setSearchFromHistory: setSearchFromHistory,
            setShowDestLocation: setShowDestLocation,
            validate: validate,
            prefilterQuery: pageData === null || pageData === void 0 ? void 0 : pageData.prefilterQuery
        };
    }, [
        isInternalCall,
        state,
        pageData
    ]);
    return /*#__PURE__*/ _jsx(SearchContext.Provider, {
        value: value,
        children: children
    });
};
export { SearchProvider };
